<template>
  <div class="alert">
    <div class="alert-content" v-html="data"></div>
    <div>
      <div @click="confirmFunc" class="alert-btn">확인</div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'mapAlertTemplate',
        props: ['confirm', 'data', 'userDevice'],
        mounted() {
          if (this.userDevice === 'mobile') {
            const RESIZE = () => {
              const WRAPPER = document.querySelector('.alert')

              if (Math.abs(window.orientation) === 90) {
                WRAPPER.style.width = window.innerWidth * 0.5 + 'px'
                WRAPPER.style.marginLeft = -(window.innerWidth * 0.5 / 2) + 'px'
                WRAPPER.style.height = window.innerHeight * 0.6 + 'px'
                WRAPPER.style.marginTop = -(window.innerHeight * 0.6 / 2) + 'px'
              } else {
                WRAPPER.style.width = window.innerWidth * 0.7 + 'px'
                WRAPPER.style.marginLeft = -(window.innerWidth * 0.7 / 2) + 'px'
                WRAPPER.style.height = window.innerHeight * 0.3 + 'px'
                WRAPPER.style.marginTop = -(window.innerHeight * 0.3 / 2) + 'px'
              }
            }
            RESIZE()
            window.addEventListener('resize', RESIZE)
          }
        },
        methods: {
          confirmFunc() {
            this.$emit('close')
            if (typeof this.confirm === 'function') this.confirm()
          }
        }
    }
</script>

<style lang="scss" scoped>
  .alert {
    position: fixed;
    z-index: 4;
    left: 50%;
    top: 50%;
    margin-left: -200px;
    margin-top: -90px;
    width: 400px;
    height: 180px;
    background-color: white;
    border: 3px solid #58b3a1;
    border-radius: 40px;
    display: table;

    > {
      div {
        display: table-row;
        &.alert-content {
          margin-top: 30px;
          display: inline-block;
        }
        .alert-btn {
          cursor: pointer;
          display: inline-block;
          width: 120px;
          height: 35px;
          line-height: 35px;
          color: white;
          border-radius: 20px;
          background-color: #58b3a1;
          margin-top: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/map/MapAlert.vue